import { CircularProgress } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = () => ({
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 300,
  },
});

const Loader = ({ classes = {} }) => (
  <div className={classes.progress}>
    <CircularProgress size={120} thickness={2} />
  </div>
);

export default withStyles(styles)(Loader);
